import { render, staticRenderFns } from "./BroadcastMessageList.vue?vue&type=template&id=8f440d3c&scoped=true"
import script from "./BroadcastMessageList.vue?vue&type=script&lang=js"
export * from "./BroadcastMessageList.vue?vue&type=script&lang=js"
import style0 from "./BroadcastMessageList.vue?vue&type=style&index=0&id=8f440d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f440d3c",
  null
  
)

export default component.exports